/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} List_SettingsInputs */



/**
* | output |
* | --- |
* | "List Settings" |
*
* @param {List_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const list_settings = /** @type {((inputs?: List_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<List_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de la liste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Listeneinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni elenco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки списка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de lista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("列表设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リスト設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सूची सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações da lista")
	return /** @type {LocalizedString} */ ("List Settings")
});